import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

interface DisqualifiedMessageProps {
  isSameDevice: boolean;
  terminatedStats: {
    isLimitReached: boolean;
    violationType: string;
  };
}

const DisqualifiedMessage: React.FC<DisqualifiedMessageProps> = ({
  isSameDevice,
  terminatedStats,
}) => {
  const navigate = useNavigate();

  const handleGoToHome = () => {
    navigate("/");
  };

  const fullScreenExitedMessage =
    "Your assessment session has ended as full-screen mode was exited. For further guidance, please reach out to your recruiter or assessment administrator.";

  const violatedMessage =
    "Your interview session has been ended due to activities that may violate the assessment guidelines. We recommend contacting your recruiter or assessment administrator for clarification and next steps.";

  const restartMessage =
    "Your interview session has been terminated following an attempt to restart the session. For assistance, please contact support.";

  const differentDeviceMessage =
    "Your interview session has been terminated because it appears to be active on another device.";

  const subTitle = () => {
    if (terminatedStats.isLimitReached) {
      switch (terminatedStats.violationType) {
        case "fullscreen_exit":
          return fullScreenExitedMessage;
        case "keyboard_shortcut":
          return violatedMessage;
        case "cursor_focus_switch":
          return violatedMessage;
        case "multiple_tabs":
          return violatedMessage;
        case "refresh_page":
          return restartMessage;
        default:
          return "";
      }
    } else {
    }
  };

  if (!isSameDevice || terminatedStats.isLimitReached) {
    return (
      <Result
        title={
          !isSameDevice
            ? "Different Device Detected."
            : "The interview session has ended."
        }
        subTitle={!isSameDevice ? differentDeviceMessage : subTitle()}
        extra={
          <Button type="primary" key="home" onClick={handleGoToHome}>
            Go To Home
          </Button>
        }
        icon={<ExclamationCircleOutlined type="primary" />}
        style={{ textAlign: "center" , maxWidth: "800px", margin: "0 auto" }}
      />
    );
  }

  return null;
};

export default DisqualifiedMessage;
